import React from 'react';
import styled from 'styled-components';
import logo from './assets/logo.png';

interface CheckinSuccessProps {
  onClose?: () => void;
}

const CheckinSuccess: React.FC<CheckinSuccessProps> = ({ onClose }) => {
  return (
    <Container>
      <SuccessContent>
        <LogoContainer>
          <LogoImage src={logo} alt="Success" />
          <MessageContainer>
            <Title>Thank you for booking with us</Title>
            <Subtitle>Your booking is confirmed and you've successfully checked in</Subtitle>
          </MessageContainer>
        </LogoContainer>
      </SuccessContent>
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 3000;
  animation: fadeIn 0.3s ease-out;
  margin: 0;
  padding: 0;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const SuccessContent = styled.div`
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const LogoContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  width: 350px;
  height: 350px;
  object-fit: contain;
  opacity: 1;
  margin: 0;
  padding: 0;
`;

const MessageContainer = styled.div`
  margin-top: -50px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  width: 350px;
`;

const Title = styled.h1`
  font-family: 'Hanken Grotesk';
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #DEDEDE;
  margin: 0;
`;

const Subtitle = styled.p`
  font-family: 'Hanken Grotesk';
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #FFFFFF;
  margin: 0;
`;

export default CheckinSuccess; 